/**
 * Real Estate terminology overrides for Colombian tenants using Spanish UI.
 */
export const realEstateEsClCoOverrides = {
  'catalog.properties.propertyType.PARCEL': 'Finca',
  'catalog.properties.propertyType.APARTMENT_STUDIO': 'Apartamento - Estudio',
  'communications.conversationCard.property.loading': 'Cargando inmueble…',
  'communications.conversationCard.property.unavailable':
    'Inmueble no disponible',
  'communications.conversationCard.property.error':
    'Inmueble temporalmente no disponible',
  'communications.conversationCard.property.fallbackType': 'Inmueble',
  'shared.propertySelector.none': 'Sin inmueble',
  'shared.propertySelector.open': 'Ver inmueble',
  'shared.propertySelector.tooltip':
    'Asigna un inmueble de interés a esta conversación',
  'shared.property.label': 'Inmueble',
  'shared.property.ofInterest': 'Inmueble de interés',
  'shared.property.noneAssigned': 'Sin inmueble asignado',
  'shared.property.searchTitle': 'Búsqueda de inmuebles',
  'shared.property.idLabel': 'Inmueble ID {id}',
  'shared.property.ofInterestRemoved': 'Se eliminó el inmueble de interés',
  'shared.property.ofInterestCleared': 'Inmueble de interés eliminado',
  'shared.property.ofInterestUpdated': 'Inmueble de interés actualizado',
  'shared.property.ofInterestWithId': 'Inmueble de interés ID {id}',
  'shared.location.map.markerTitle': 'Marcador de ubicación del inmueble',
  'communications.filters.propertyOfInterest': 'Inmueble de interés',
  'catalog.properties.title': 'Inmuebles',
  'websites.settings.navigation.properties': 'Inmuebles',
  'websites.settings.analytics.propertiesConsulted': 'Inmuebles consultados',
  'websites.settings.analytics.topProperties': 'Inmuebles más consultados',
  'websites.settings.analytics.topProperties.empty':
    'Aún no hay clicks asociados a inmuebles.',
  'websites.settings.analytics.propertyFallback': 'Inmueble {id}',
  'websites.settings.analytics.recentClicks.noProperty':
    'Click sin inmueble asociado',
  'websites.settings.brochure.faqs.placeholder':
    'Cómo agendo una visita? | Escríbenos por WhatsApp y coordinamos contigo.\nPublican inmuebles en portales? | Sí, según el plan comercial de cada inmueble.',
  'websites.settings.brochure.externalLinks.placeholder':
    'Portal de inmuebles | https://portal.example.com\nSitio asociado | https://partner.example.com',
  'websites.settings.whatsApp.cta.propertyCard.label': 'Tarjeta de inmueble',
  'websites.settings.whatsApp.cta.propertyCard.defaultMessage':
    'Hola, me interesa el inmueble {propertyTitle} ({propertyCode}) que vi en {siteUrl}.',
  'websites.settings.whatsApp.cta.propertyDetail.label': 'Detalle de inmueble',
  'websites.settings.whatsApp.cta.propertyDetail.defaultMessage':
    'Hola, quiero consultar por {propertyTitle} ({propertyCode}) en {propertyUrl}.',
  'websites.settings.whatsApp.cta.scheduleVisit.defaultMessage':
    'Hola, quiero coordinar una visita para {propertyTitle} ({propertyCode}).',
  'catalog.properties.table.emptyState.title': 'No se encontraron inmuebles',
  'catalog.properties.error.title': 'No se pudieron cargar los inmuebles',
  'catalog.properties.publications.page.subtitle':
    'Monitorea las publicaciones más recientes de portales en todos los inmuebles.',
  'catalog.properties.publications.table.property': 'Inmueble',
  'catalog.properties.form.isActive': 'Inmueble activo',
  'catalog.properties.form.propertyType': 'Tipo de inmueble',
  'catalog.properties.form.featuresHelp':
    'Marca las amenidades y atributos que correspondan a este inmueble.',
  'catalog.properties.import.title': 'Importar inmuebles',
  'catalog.properties.import.alert.success':
    'La importación de tus inmuebles ha comenzado. Puede tardar unos minutos en completarse.',
  'catalog.properties.import.filter.toggle':
    'Importar sólo inmuebles que coincidan',
  'catalog.properties.import.syncMissingPolicy.label':
    'Si un inmueble deja de llegar',
  'catalog.properties.import.kutt.filter.column.propertyType':
    'Tipo de inmueble',
  'catalog.properties.import.ilist.filter.column.propertyType':
    'Tipo de inmueble',
  'catalog.properties.import.assignment.alert.userRequired':
    'Selecciona un usuario para asignar los inmuebles.',
  'catalog.properties.import.assignment.help.keep':
    'No asigna ni cambia el usuario asignado en los inmuebles importados.',
  'catalog.properties.import.assignment.help.forceUser':
    'Asigna todos los inmuebles importados al usuario seleccionado (sobrescribe la asignación actual).',
  'catalog.properties.confirmDeactivate.title': 'Desactivar inmueble',
  'catalog.properties.confirmDeactivate.fallbackName': 'este inmueble',
  'catalog.properties.confirmDeactivate.messageSuffix':
    '? El inmueble dejará de estar activo en Comos.',
  'catalog.properties.confirmDeactivate.publicationImpact':
    'Si este inmueble tiene publicaciones activas vinculadas, también se despublicarán en sus respectivos portales.',
  'catalog.properties.form.edit': 'Editar inmueble',
  'catalog.properties.form.create': 'Crear nuevo inmueble',
  'catalog.properties.form.namePlaceholder': 'Nombre del inmueble',
  'catalog.properties.form.descriptionPlaceholder': 'Describe el inmueble',
  'catalog.properties.location.preview.empty':
    'Agrega una dirección o coordenadas para previsualizar la ubicación del inmueble.',
  'catalog.properties.editor.createTitle': 'Crear inmueble',
  'catalog.properties.editor.editTitle': 'Editar inmueble',
  'catalog.properties.editor.createSubtitle':
    'Comienza con la información base y continúa con la publicación una vez guardado el inmueble.',
  'catalog.properties.editor.editSubtitle':
    'Mantén los datos del inmueble y su estado de publicación en un solo lugar.',
  'catalog.properties.editor.backToList': 'Volver a inmuebles',
  'catalog.properties.editor.sections.featuresDescription':
    'Marca las amenidades, equipamiento y condiciones especiales asociadas a este inmueble.',
  'catalog.properties.editor.sections.metadataDescription':
    'Mantén referencias del origen y trazabilidad de importación para este inmueble.',
  'catalog.properties.editor.placeholders.name': 'Nombre del inmueble',
  'catalog.properties.editor.placeholders.description':
    'Describe el inmueble y sus principales atributos comerciales.',
  'catalog.properties.editor.loadErrorTitle':
    'No fue posible cargar el inmueble',
  'catalog.properties.editor.publishing.description':
    'Revisa y administra las publicaciones asociadas a este inmueble.',
  'catalog.properties.editor.publishing.syncTimeline.empty':
    'Todavía no hay eventos de sincronización para este inmueble.',
  'catalog.properties.editor.publishing.saveFirstTitle':
    'Guarda primero el inmueble',
  'catalog.properties.editor.publishing.saveFirstDescription':
    'La sección de publicación estará disponible cuando el inmueble exista en Comos.',
  'catalog.properties.editor.publishing.unsupportedDescription':
    'La operación de este inmueble todavía no es publicable en Mercado Libre.',
  'catalog.properties.editor.publishing.sourceOfTruthSyncDescription':
    'Este inmueble está administrado por una integración. Los cambios en Comos pueden ser reemplazados en la próxima actualización.',
  'catalog.properties.editor.publishing.sourceOfTruthPublishDescription':
    'Este inmueble se originó en Mercado Libre. Revisa con cuidado los cambios de publicación para no sobrescribir inesperadamente el origen sincronizado.',
  'catalog.properties.editor.publishing.actions.publishInactiveTooltip':
    'Activa el inmueble en Comos antes de publicarlo o actualizarlo en Mercado Libre.',
  'catalog.properties.editor.confirmRepublish.description':
    'Guardar estos cambios actualizará las publicaciones activas vinculadas a este inmueble en sus respectivos portales.',
  'catalog.properties.editor.confirmDeactivate.title': 'Desactivar inmueble',
  'catalog.properties.editor.confirmDeactivate.description':
    'Guardar estos cambios desactivará este inmueble en Comos.',
  'catalog.properties.alert.create.success': 'Inmueble creado correctamente',
  'catalog.properties.alert.create.error': 'Error al crear el inmueble',
  'catalog.properties.alert.update.success':
    'Inmueble actualizado correctamente',
  'catalog.properties.alert.update.error': 'Error al actualizar el inmueble',
  'catalog.properties.meli.modal.description':
    'Valida y gestiona la publicación de este inmueble en Mercado Libre.',
  'catalog.properties.meli.unsupportedOperation':
    'Este inmueble no tiene una operación compatible para publicar en Mercado Libre.',
  'catalog.properties.meli.category.helpDescription':
    'Comos selecciona la categoría de Mercado Libre a partir del tipo de inmueble y la operación. Sólo necesitas completar los datos estructurados.',
  'catalog.properties.meli.category.inlineDescription':
    'Comos calcula esta categoría a partir del tipo de inmueble, la operación y los campos estructurados.',
  'catalog.properties.meli.category.autoResolved':
    'Seleccionada automáticamente según los datos del inmueble.',
  'catalog.properties.meli.category.unavailable':
    'Completa los datos estructurados del inmueble para resolver la categoría automáticamente.',
  'catalog.properties.meli.images.description':
    'Selecciona cuáles imágenes del inmueble se usarán en esta publicación.',
  'catalog.properties.meli.images.empty':
    'Agrega imágenes del inmueble en la sección multimedia antes de publicar.',
  'catalog.properties.meli.images.selectionHint':
    'Si no seleccionas un subconjunto, se usarán todas las imágenes del inmueble.',
  'catalog.properties.meli.validation.issue.missing_title':
    'El título del inmueble es obligatorio para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_description':
    'La descripción del inmueble es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_property_type':
    'El tipo de inmueble es obligatorio para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_condition':
    'La condición del inmueble es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_operation':
    'La operación del inmueble es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.currentPublication.syncManagedDescription':
    'Los cambios detectados en la publicación origen pueden sincronizarse en Comos y actualizar este inmueble.',
  'catalog.properties.meli.currentPublication.history.details.propertyAction':
    'Inmueble',
  'catalog.properties.media.title': 'Archivos del inmueble',
  'catalog.properties.media.description':
    'Sube los archivos que representan este inmueble. Se reutilizarán en la ficha y en las publicaciones de portales.',
  'catalog.properties.media.empty':
    'Todavía no hay archivos agregados a este inmueble.',
  'catalog.properties.media.dropzone.helper':
    'Suelta los archivos para agregarlos al inmueble.',
  'sidebar.properties': 'Inmuebles',
  'settings.integrations.sidebar.realEstateProviders': 'Inmuebles',
  'settings.integrations.realEstate.title': 'Inmuebles',
  'settings.integrations.wasi.subtitle':
    'Conecta Wasi usando la API para mantener tus inmuebles sincronizados.',
  'settings.integrations.wasi.syncMissingPolicy.label':
    'Si un inmueble deja de llegar',
  'settings.integrations.wasi.propertyScope.label': 'Qué inmuebles sincronizar',
  'settings.integrations.wasi.propertyScope.help':
    'Elige si la sincronización debe considerar todos los inmuebles del vendedor o solo los activos.',
  'settings.integrations.meli.subtitle':
    'Conecta Mercado Libre para mantener tus inmuebles sincronizados.',
  'settings.integrations.meli.connected.help':
    'Mercado Libre está conectado. Tus inmuebles se mantendrán sincronizados.',
  'settings.integrations.meli.mode.confirm.warning':
    'Elige "Sincronizar" si sigues gestionando tus inmuebles en Mercado Libre. Elige "Publicar" si prefieres administrar y actualizar tus publicaciones directamente en Comos.',
  'settings.integrations.toppropiedades.subtitle':
    'Importa tus inmuebles desde TopPropiedades (API)',
  'settings.integrations.toppropiedades.syncMissingPolicy.label':
    'Si un inmueble deja de llegar',
  'settings.integrations.toppropiedades.propertyScope.label':
    'Qué inmuebles sincronizar',
  'settings.integrations.toppropiedades.propertyScope.help':
    'Elige si la sincronización debe considerar todos los inmuebles del vendedor o solo los activos.',
  'settings.integrations.2clics.subtitle':
    'Importa tus inmuebles desde 2clics (API)',
  'settings.integrations.2clics.syncMissingPolicy.label':
    'Si un inmueble deja de llegar',
  'settings.integrations.2clics.propertyScope.label':
    'Qué inmuebles sincronizar',
  'settings.integrations.2clics.propertyScope.help':
    'Elige si la sincronización debe considerar todos los inmuebles del vendedor o solo los activos.',
  'tools.toolConfig.aliasPlaceholder.listProperties': 'Ej: Listar inmuebles',
  'settings.funnels.statusDescription.example.main':
    '\n1. Saluda y confirma motivo\n\t- Si menciona un inmueble, entonces agenda visita y procede al paso 2\n\t- Si no lo menciona, entonces solicita zona, presupuesto, nombre y teléfono\n2. Revisa requisitos\n\t- Si cumple, entonces mueve la conversación al estado "Gestión"\n\t- Si no cumple, entonces mueve la conversación al estado "No calificado"',
};
